import { EnemyId } from "../state/runState";
import type { PerkId } from "./perks";

export type EnemyIntent = "attack" | "defend";

export type EnemyDef = {
  id: EnemyId;
  name: string;
  maxHp: number;
  atk: number;
  armor: number;
  /** Probability (0-1) that enemy will defend instead of attack. Default 0. */
  defendChance?: number;
  perks?: PerkId[];
};

export type EnemyInstance = {
  id: EnemyId;
  name: string;
  maxHp: number;
  hp: number;
  atk: number;
  armor: number;
  /** Current intended action for next turn */
  intent: EnemyIntent;
  /** Whether currently defending (damage reduction active) */
  isDefending: boolean;
  /** Probability to defend */
  defendChance: number;
  perks: PerkId[];
  isAlive: () => boolean;
};

export const ENEMIES: Record<EnemyId, EnemyDef> = {
  goblin: {
    id: "goblin",
    name: "Goblin",
    maxHp: 20,
    atk: 4,
    armor: 5,
    defendChance: 0.25,
  },
  bat: {
    id: "bat",
    name: "Bat",
    maxHp: 8,
    atk: 2,
    armor: 0,
    perks: ["perk_lifesteal"],
  },
  skeleton: {
    id: "skeleton",
    name: "Skeleton",
    maxHp: 15,
    atk: 5,
    armor: 2,
    defendChance: 0.15,
  },
  slime: {
    id: "slime",
    name: "Slime",
    maxHp: 12,
    atk: 3,
    armor: 1,
    defendChance: 0.1,
  },
  spider: {
    id: "spider",
    name: "Spider",
    maxHp: 10,
    atk: 4,
    armor: 0,
    defendChance: 0.2,
    perks: ["perk_thorns"],
  },
};

export const createEnemyInstance = (def: EnemyDef, nameSuffix?: string): EnemyInstance => {
  const instance: EnemyInstance = {
    id: def.id,
    name: nameSuffix ? `${def.name} ${nameSuffix}` : def.name,
    maxHp: def.maxHp,
    hp: def.maxHp,
    atk: def.atk,
    armor: def.armor,
    intent: "attack",
    isDefending: false,
    defendChance: def.defendChance ?? 0,
    perks: def.perks ? [...def.perks] : [],
    isAlive: () => instance.hp > 0,
  };
  return instance;
};
